module.exports = ".mdi-2x{\r\n    font-size: 2em;\r\n}"